import { useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import ProtectedRoute from "./common/ProtectedRoute"; 
import Topbar from "./scenes/global/Topbar";
import Sidebar from "./scenes/global/Sidebar";

import UserAccounts from "./scenes/useraccounts";
import Subscriptions from "./scenes/subscriptions";

import Landing from "./pages/landing";
import Login from "./pages/login";
import Logout from "./pages/logout";
import Reset from "./pages/reset";
import Signup from "./pages/signup";
import ContactUs from "./pages/contactus";
import Subscribe from "./pages/subscribe";
import Pricing from "./pages/pricing";
import CheckoutSuccess from "./pages/subscribe/steps/checkoutsuccess";
import CheckoutCancelled from "./pages/subscribe/steps/checkoutcancel";
import CheckoutSuccessDodo from "./pages/subscribe/steps/checkoutsuccessdodo";
import CheckoutCancelledDodo from "./pages/subscribe/steps/checkoutcanceldodo";

import ConfirmMarketingOptIn from "./pages/confirmmarketingoptin";

import PaidMarketingLandingPage from "./pages/paidmarketinglandingpage";

import PaidMarketingLandingPageReddit from "./pages/paidmarketinglandingpagereddit";

import  OptOutOfMarketingEmails from "./pages/optoutmarketingemails";

import  OptOutOfPPCMarketingEmails from "./pages/optoutppcmarketingemails";

import  DemoPage from "./pages/demopage";

import TermsOfService from "./pages/termsofservice";

import Dashboard from "./scenes/dashboard";

import Unauthorized from "./scenes/unauthorized";

import NotFound from "./pages/pagenotfound";

import Organization from "./scenes/organization";
import Employees from "./scenes/employees";
import ContractorCompanies from "./scenes/contractorcompanies";
import Contractors from "./scenes/contractors";
import Clients from "./scenes/clients";
import DirectDeposits from "./scenes/directdeposits";
import TaxCalculations from "./scenes/taxcalculations";
import Garnishments from "./scenes/garnishments";
import GarnishmentsByStatus from "./scenes/garnishments/indexByStatus";
import GarnishmentsByGarnishmentType from "./scenes/garnishments/indexByGarnishmentType";
import PaymentPeriod from "./scenes/paymentperiod";
import PaymentPeriodByPayrollCycle from "./scenes/paymentperiod/indexByPayrollCycle";
import EmployeeTimeCard from "./scenes/employeetimecard";
import EmployeeTimeCardByShiftType from "./scenes/employeetimecard/indexByShiftType";
import ContractorTimeCard from "./scenes/contractortimecard";
import ContractorTimeCardByShiftType from "./scenes/contractortimecard/indexByShiftType";
import EmployeePayroll from "./scenes/employeepayroll";
import EmployeePayrollByPaymentMethod from "./scenes/employeepayroll/indexByPaymentMethod";
import EmployeePayrollByStatus from "./scenes/employeepayroll/indexByStatus";
import ContractorPayroll from "./scenes/contractorpayroll";
import ContractorPayrollByPaymentMethod from "./scenes/contractorpayroll/indexByPaymentMethod";
import ContractorPayrollByStatus from "./scenes/contractorpayroll/indexByStatus";
import ClientInvoices from "./scenes/clientinvoices";
import ClientInvoicesByStatus from "./scenes/clientinvoices/indexByStatus";
import ClientInvoicesByPaymentMethod from "./scenes/clientinvoices/indexByPaymentMethod";


import ToastMessageDisplay from "./common/ToastMessageDisplay"; 
import { UserProvider } from "./common/UserContext";
import { ApplicationModeProvider } from "./common/ApplicationModeContext";
import { UserCountProvider } from "./common/UserCountContext";
import { AccountProvider } from "./common/AccountContext";

import Bar from "./scenes/bar";
import Line from "./scenes/line";
import Pie from "./scenes/pie";
import Geography from "./scenes/geography";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, useMode } from "./theme";
import Calendar from "./scenes/calendar/calendar";
import { Navigate } from "react-router-dom";

function App() {
  const [theme, colorMode] = useMode();
  const [isSidebar, setIsSidebar] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");  // Add this line to hold the search term
  const location = useLocation();

  const publicPaths = ["/", 
    "/index.html", 
    "/login", 
    "/logout", 
    "/reset", 
    "/signup",
    "/contactus", 
    "/subscribe", 
    "/pricing", 
    "/terms-of-service", 
    "/confirm-marketing-opt-in",
    "/opt-out-of-marketing-emails",
    "/opt-out-of-ppc-marketing-emails",
    "/checkout-success", 
    "/checkout-cancelled",
    "/checkout-dodo-success", 
    "/checkout-dodo-cancelled",

    "/not-found",
    "/limited-time-discount-offer",
    "/demo",
    "/i-built-a-tool"];

  const isPublic = publicPaths.includes(location.pathname);

/************************************ PUBLIC PAGES ********************************************* */

if (isPublic) {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/index.html" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/logout" element={<Logout />} />
      <Route path="/reset" element={<Reset />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/contactus" element={<ContactUs />} />
      <Route path="/subscribe" element={<Subscribe />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/terms-of-service" element={<TermsOfService />} />
      <Route path="/confirm-marketing-opt-in" element={<ConfirmMarketingOptIn />} />
      <Route path="/opt-out-of-marketing-emails" element={<OptOutOfMarketingEmails />} />
      <Route path="/opt-out-of-ppc-marketing-emails" element={<OptOutOfPPCMarketingEmails />} />
      <Route path="/limited-time-discount-offer" element={<PaidMarketingLandingPage />} />
      <Route path="/i-built-a-tool" element={<PaidMarketingLandingPageReddit />} />
      <Route path="/demo" element={<DemoPage />} />

      <Route path="/checkout-success" element={<CheckoutSuccess />} />
      <Route path="/checkout-cancelled" element={<CheckoutCancelled />} />
      <Route path="/checkout-dodo-success" element={<CheckoutSuccessDodo />} />
      <Route path="/checkout-dodo-cancelled" element={<CheckoutCancelledDodo />} />

      <Route path="/not-found" element={<NotFound />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

/************************************ PRIVATE PAGES ********************************************* */

  return (
    <ApplicationModeProvider>  
      <UserProvider>
        <UserCountProvider>
          <AccountProvider>
            <ColorModeContext.Provider value={colorMode}>
              <ThemeProvider theme={theme}>
                <CssBaseline />
                <div className="app">
                  <Sidebar isSidebar={isSidebar} />
                  <main className="content">
                    <Topbar setIsSidebar={setIsSidebar} searchTerm={searchTerm} setSearchTerm={setSearchTerm}/>
                    <Routes>
                      <Route path="/app" element={<ProtectedRoute element={<Dashboard />} />} />

                      <Route path="/organization" element={<ProtectedRoute element={<Organization searchTerm={searchTerm} />} />} />
<Route path="/employees" element={<ProtectedRoute element={<Employees searchTerm={searchTerm} />} />} />
<Route path="/contractorcompanies" element={<ProtectedRoute element={<ContractorCompanies searchTerm={searchTerm} />} />} />
<Route path="/contractors" element={<ProtectedRoute element={<Contractors searchTerm={searchTerm} />} />} />
<Route path="/clients" element={<ProtectedRoute element={<Clients searchTerm={searchTerm} />} />} />
<Route path="/directdeposits" element={<ProtectedRoute element={<DirectDeposits searchTerm={searchTerm} />} />} />
<Route path="/directdeposits/list" element={<ProtectedRoute element={<DirectDeposits searchTerm={searchTerm} />} />} />
<Route path="/taxcalculations" element={<ProtectedRoute element={<TaxCalculations searchTerm={searchTerm} />} />} />
<Route path="/taxcalculations/list" element={<ProtectedRoute element={<TaxCalculations searchTerm={searchTerm} />} />} />
<Route path="/garnishments" element={<ProtectedRoute element={<Garnishments searchTerm={searchTerm} />} />} />
<Route path="/garnishments/list" element={<ProtectedRoute element={<Garnishments searchTerm={searchTerm} />} />} />
<Route path="/garnishments/status" element={<ProtectedRoute element={<GarnishmentsByStatus searchTerm={searchTerm} />} />} />
<Route path="/garnishments/garnishmenttype" element={<ProtectedRoute element={<GarnishmentsByGarnishmentType searchTerm={searchTerm} />} />} />
<Route path="/paymentperiod" element={<ProtectedRoute element={<PaymentPeriod searchTerm={searchTerm} />} />} />
<Route path="/paymentperiod/list" element={<ProtectedRoute element={<PaymentPeriod searchTerm={searchTerm} />} />} />
<Route path="/paymentperiod/payrollcycle" element={<ProtectedRoute element={<PaymentPeriodByPayrollCycle searchTerm={searchTerm} />} />} />
<Route path="/employeetimecard" element={<ProtectedRoute element={<EmployeeTimeCard searchTerm={searchTerm} />} />} />
<Route path="/employeetimecard/list" element={<ProtectedRoute element={<EmployeeTimeCard searchTerm={searchTerm} />} />} />
<Route path="/employeetimecard/shifttype" element={<ProtectedRoute element={<EmployeeTimeCardByShiftType searchTerm={searchTerm} />} />} />
<Route path="/contractortimecard" element={<ProtectedRoute element={<ContractorTimeCard searchTerm={searchTerm} />} />} />
<Route path="/contractortimecard/list" element={<ProtectedRoute element={<ContractorTimeCard searchTerm={searchTerm} />} />} />
<Route path="/contractortimecard/shifttype" element={<ProtectedRoute element={<ContractorTimeCardByShiftType searchTerm={searchTerm} />} />} />
<Route path="/employeepayroll" element={<ProtectedRoute element={<EmployeePayroll searchTerm={searchTerm} />} />} />
<Route path="/employeepayroll/list" element={<ProtectedRoute element={<EmployeePayroll searchTerm={searchTerm} />} />} />
<Route path="/employeepayroll/paymentmethod" element={<ProtectedRoute element={<EmployeePayrollByPaymentMethod searchTerm={searchTerm} />} />} />
<Route path="/employeepayroll/status" element={<ProtectedRoute element={<EmployeePayrollByStatus searchTerm={searchTerm} />} />} />
<Route path="/contractorpayroll" element={<ProtectedRoute element={<ContractorPayroll searchTerm={searchTerm} />} />} />
<Route path="/contractorpayroll/list" element={<ProtectedRoute element={<ContractorPayroll searchTerm={searchTerm} />} />} />
<Route path="/contractorpayroll/paymentmethod" element={<ProtectedRoute element={<ContractorPayrollByPaymentMethod searchTerm={searchTerm} />} />} />
<Route path="/contractorpayroll/status" element={<ProtectedRoute element={<ContractorPayrollByStatus searchTerm={searchTerm} />} />} />
<Route path="/clientinvoices" element={<ProtectedRoute element={<ClientInvoices searchTerm={searchTerm} />} />} />
<Route path="/clientinvoices/list" element={<ProtectedRoute element={<ClientInvoices searchTerm={searchTerm} />} />} />
<Route path="/clientinvoices/status" element={<ProtectedRoute element={<ClientInvoicesByStatus searchTerm={searchTerm} />} />} />
<Route path="/clientinvoices/paymentmethod" element={<ProtectedRoute element={<ClientInvoicesByPaymentMethod searchTerm={searchTerm} />} />} />


                      <Route path="/pie" element={<ProtectedRoute element={<Pie />} />} />
                      <Route path="/line" element={<ProtectedRoute element={<Line />} />} />
                      <Route path="/calendar" element={<ProtectedRoute element={<Calendar />} />} />
                      <Route path="/geography" element={<ProtectedRoute element={<Geography />} />} />

                      <Route path="/useraccounts" element={<ProtectedRoute element={<UserAccounts />} role="admin" />} />
                      <Route path="/subscriptions" element={<ProtectedRoute element={<Subscriptions />} role="admin" />} />

                      <Route path="/unauthorized" element={<ProtectedRoute element={<Unauthorized />} />} />

                      <Route path="*" element={<Navigate to="/not-found" replace />} />

                    </Routes>
                    <ToastMessageDisplay />
                  </main>
                </div>
              </ThemeProvider>
            </ColorModeContext.Provider>
            </AccountProvider>
        </UserCountProvider>
      </UserProvider>
    </ApplicationModeProvider>
  );
}

export default App;
